import axios from "axios";

const http = axios.create({
  withCredentials: true,
  baseURL: process.env.VUE_APP_BACKEND_API,
  headers: {
    "Content-Type": "application/json",
  },
});

export const flushClientCaches = () => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.sessionStorage?.clear();
    window.localStorage?.removeItem("vuex");
    window.localStorage?.removeItem("stores");
    window.localStorage?.removeItem("ebm_background_tasks");
  } catch (storageError) {
    void storageError;
  }

  if ("caches" in window) {
    caches
      .keys()
      .then((keys) => Promise.all(keys.map((key) => caches.delete(key))))
      .catch(() => undefined);
  }
};

// Request interceptor for headers
http.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  // Let TanStack Query handle caching - only prevent browser cache
  config.headers["Cache-Control"] = "no-cache";
  config.headers["Pragma"] = "no-cache";

  return config;
});

http.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";

    // Only logout on 401 for authentication-related endpoints
    // Only logout if the 401 is specifically from the auth endpoint
    // Skip redirect when on the /auth/session page (token-based auth flow)
    if (
      status === 401 &&
      url.includes("/v1/auth") &&
      !url.includes("/v1/auth/provider/2fa/verify") &&
      !window.location.pathname.startsWith("/auth/session")
    ) {
      // Hard redirect to login to avoid router-beforeEach loops
      flushClientCaches();
      window.location.replace("/");
      return Promise.reject(error);
    }
    return Promise.reject(error);
  },
);

export default http;
